"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wasCallAnOutboundCall = void 0;
const was_call_a_callback_1 = require("./was-call-a-callback");
function wasCallAnOutboundCall(call) {
    return call.new_direction === 'OUTGOING' && !(0, was_call_a_callback_1.wasCallACallback)(call);
}
exports.wasCallAnOutboundCall = wasCallAnOutboundCall;
